import React from "react";
import { icon } from "../functions/icons";

export function Chip({ label, variant = "default", size = "medium", onClick, onClose, disabled = false, iconStart, iconEnd, className = "", style = {}, input }) {
  const isClickable = !!onClick && !disabled;
  const classes = ["chip", `chip--${variant}`, `chip--${size}`, disabled ? "chip--disabled" : "", isClickable ? "chip--clickable chip--hoverable" : "", className].join(" ");
  const handleClose = e => { e.stopPropagation(); if (!disabled && onClose) onClose(e); };
  const handleKeyDown = e => { if (!disabled && onClick && (e.key === "Enter" || e.key === " ")) onClick(); };
  return (
    <div
      className={classes}
      style={style}
      onClick={() => !disabled && onClick && onClick()}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={handleKeyDown}
    >
      {iconStart && <span className="chip__icon chip__icon--start">{icon(iconStart)}</span>}
      <span className="chip__label">{label}</span>
      {onClose && <button type="button" className="chip__close" onClick={handleClose} aria-label="Remove chip" tabIndex={-1}>×</button>}
      {iconEnd && !onClose && <span className="chip__icon chip__icon--end">{icon(iconEnd)}</span>}
      {input && input}
    </div>
  );
}
